import Button from '@material-ui/core/Button'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const RowLink = styled(Button)`
  && {
    padding: 0 10px;
    min-height: 32px;
    text-transform: uppercase;
    white-space: nowrap;
    font-size: 0.8125rem;
    &:hover {
      text-decoration: none;
      & span {
        color: ${props => props.theme.palette.primary.main};
      }
    }
  }
`

const RowActionLinkExternal = ({ children, className, href, download }) => (
  <ThemeProvider theme={theme}>
    <RowLink color="primary" className={className} href={href} target="_blank" download={download}>
      {children}
    </RowLink>
  </ThemeProvider>
)

export default RowActionLinkExternal
